import React, { useState, useEffect } from 'react';
import { fetchLinkPreview, getDomainFromUrl } from '../../utils/linkPreview';
import '../../css/chats/LinkPreview.css';

/**
 * Карточка превью ссылки (как в Telegram).
 * Загружает meta-теги (OG, Twitter Cards) целевого сайта через CORS-прокси
 * и отображает title, description, image.
 *
 * @param {Object} props
 * @param {string} props.url — URL для превью
 * @param {boolean} [props.isOwn] — собственное сообщение (для стилизации)
 */
export default function LinkPreview({ url, isOwn = false }) {
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        let cancelled = false;

        setLoading(true);
        setError(false);
        setImageError(false);

        fetchLinkPreview(url)
            .then(data => {
                if (!cancelled) {
                    setPreview(data);
                    setError(!data);
                }
            })
            .catch(() => {
                if (!cancelled) setError(true);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, [url]);

    // Не показываем карточку при ошибке — оставляем просто кликабельную ссылку
    if (loading || error || !preview) {
        return (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={`link-preview__fallback ${isOwn ? 'link-preview__fallback--own' : ''}`}
            >
                {url}
            </a>
        );
    }

    const domain = getDomainFromUrl(preview.url || url);

    return (
        <a
            href={preview.url || url}
            target="_blank"
            rel="noopener noreferrer"
            className={`link-preview ${isOwn ? 'link-preview--own' : ''}`}
        >
            {preview.image && !imageError && (
                <div className="link-preview__image-wrap">
                    <img
                        src={preview.image}
                        alt={preview.title || domain}
                        className="link-preview__image"
                        loading="lazy"
                        onError={() => setImageError(true)}
                    />
                </div>
            )}
            <div className="link-preview__content">
                {preview.title && (
                    <div className="link-preview__title">{preview.title}</div>
                )}
                {preview.description && (
                    <div className="link-preview__description">{preview.description}</div>
                )}
                <div className="link-preview__domain">
                    {preview.siteName || domain}
                </div>
            </div>
        </a>
    );
}
